export default __webpack_public_path__ + "static/media/Settings.98fbc877.svg";